import type { ThemeConfig } from "types/theme";

const STORAGE_KEY = "themePreviewConfig";
export const THEME_PREVIEW_FRAME_NAME = "theme-setter-preview";

type PreviewPayload = {
  customer?: string;
  config: ThemeConfig;
  updatedAt: number;
};

const isBrowser = typeof window !== "undefined";

export const saveThemePreviewConfig = (
  customer: string | undefined,
  config: ThemeConfig
) => {
  if (!isBrowser) return;
  const payload: PreviewPayload = {
    customer,
    config,
    updatedAt: Date.now(),
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore storage failures
  }
};

export const clearThemePreviewConfig = () => {
  if (!isBrowser) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
};

export const readThemePreviewConfig = (): PreviewPayload | null => {
  if (!isBrowser) return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PreviewPayload;
  } catch {
    return null;
  }
};

export const isThemePreviewMode = (): boolean => {
  if (!isBrowser) return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("theme-preview") === "1") {
      return true;
    }
    return window.name === THEME_PREVIEW_FRAME_NAME;
  } catch {
    return false;
  }
};

export { STORAGE_KEY as THEME_PREVIEW_STORAGE_KEY };
